import { inject } from '@angular/core';
import { Store } from '@ngxs/store';
import { BusinessState } from '@state/business';
import { filter, map, switchMap, tap } from 'rxjs/operators';
import { NavigationService } from 'src/app/shared/services/nav/nav.service';
import { CanActivateFn } from '@angular/router';

export const MaliciousUserGuard: CanActivateFn = () => {
	const navigationService = inject(NavigationService);
	const store = inject(Store);
	return store.select(BusinessState.getLoaded).pipe(
		filter((loaded) => loaded),
		switchMap(() => store.select(BusinessState.getBusiness)),
		map((business) => !business.maliciousUser),
		tap((goodUser) => !goodUser && navigationService.goToMaliciousUser()),
	);
};
